import { Button } from "@/react/ui/button"
import { Icon } from "~/react/ui/icon"

// Legacy format: single action with url/text/htmlOptions
export type IssueItemLegacyAction = {
  url: string
  text: string
  htmlOptions?: Record<string, string>
} | null

// New format: multiple actions with label/href
export type IssueItemAction = {
  label?: string
  href?: string
  htmlOptions?: Record<string, string> // Support htmlOptions in new format too
}

type IssueItemProps = {
  title: string
  subtitle?: string
  description?: string // Legacy prop name, maps to subtitle
  severityLabel: string
  severityIcon: string
  severityClass: string
  // Support both formats
  action?: IssueItemLegacyAction // Legacy: single action
  actions?: IssueItemAction[] // New: multiple actions
}

export function IssueItem({
  title,
  subtitle,
  description,
  severityLabel,
  severityIcon,
  severityClass,
  action,
  actions = [],
}: IssueItemProps) {
  // Use subtitle or description (legacy)
  const displaySubtitle = subtitle || description || ""

  // Convert legacy single action to new format
  const normalizedActions: IssueItemAction[] = []

  if (action && action.url && action.text) {
    normalizedActions.push({
      label: action.text,
      href: action.url,
      htmlOptions: action.htmlOptions,
    })
  }

  // Add new format actions
  if (actions.length > 0) {
    normalizedActions.push(...actions)
  }

  // Filter valid actions
  const validActions = normalizedActions.filter(
    (action) => action && action.label && action.href,
  )

  return (
    <li className={`issues-feed-item ${severityClass}`}>
      <h3 className="text-xs-medium m-0">{title}</h3>
      <p className="text-2xs text-hint m-0">{displaySubtitle}</p>
      <footer className="issues-feed-item__footer">
        {validActions.length > 0 && (
          <div className="issues-feed-item__actions">
            {validActions.map((action, actionIndex) => (
              <Button key={actionIndex} asChild size="xs" variant="default">
                <a
                  href={action.href}
                  target="_blank"
                  rel="noreferrer"
                  {...(action.htmlOptions || {})}
                >
                  {action.label}
                </a>
              </Button>
            ))}
          </div>
        )}

        <div className="issues-feed-item__type ml-auto">
          <Icon
            icon={severityIcon}
            size="xs"
            className="issues-feed-item__icon"
          />
          <span className="text-2xs-medium">{severityLabel}</span>
        </div>
      </footer>
    </li>
  )
}
